import React from 'react';

/**
 * Club_Product Quantity Counter (Figma 3145:10956).
 *
 * 66×26, fondo --muted, radio 6, sin borde. Los botones son 18×18 sobre
 * --background.
 *
 * El número del medio es EDITABLE, y esa es una diferencia deliberada con el
 * frame. El diseño dibuja solo «− N +», pero Kong pidió el 16-ago poder teclear
 * la cantidad porque «para poner 4 veces algo es más cómodo que darle a añadir»
 * varias (#467). Un contador de solo pulsar obliga a 15 toques para 15 unidades.
 *
 * Así que se conserva la forma del frame y se le añade el teclado: se puede
 * pulsar ± o escribir. Si el frame quiere reflejarlo, es un campo de 14 de ancho
 * en el hueco del número.
 *
 * Vacío significa 1 al añadir — el gesto de siempre para quien no sepa del
 * campo. Por eso `value` es una cadena y no un número: hay que distinguir «no ha
 * tocado nada» de «ha escrito 0».
 */
export default function QuantityCounter({
  value = '',
  onChange,
  max = Infinity,
  disabled = false,
  label = 'Cantidad',
}) {
  const num = parseInt(value, 10) || 0;
  const limpia = (v) => String(v).replace(/[^0-9]/g, '').slice(0, 4);
  const paso = (n) => {
    if (n < 0 || n > max) return;
    onChange?.(n === 0 ? '' : String(n));
  };
  const btn =
    'flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-sm bg-[var(--background)] ' +
    'text-[var(--foreground)] leading-none transition-transform active:scale-95 ' +
    'disabled:opacity-40 disabled:active:scale-100';

  return (
    <div className="inline-flex h-[26px] items-center gap-1 rounded-sm bg-[var(--muted)] p-1">
      <button
        type="button"
        className={btn}
        onClick={() => paso(num - 1)}
        disabled={disabled || num <= 0}
        aria-label="Quitar uno"
        tabIndex={-1}
      >
        −
      </button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        aria-label={label}
        value={value}
        placeholder="1"
        disabled={disabled}
        onFocus={(e) => e.target.select()}
        onChange={(e) => onChange?.(limpia(e.target.value))}
        className="h-full w-[22px] bg-transparent p-0 text-center text-xs font-medium tabular-nums text-[var(--foreground)] placeholder:font-normal placeholder:text-[var(--muted-foreground)] focus:outline-none disabled:text-[var(--muted-foreground)]"
      />
      <button
        type="button"
        className={btn}
        onClick={() => paso(num + 1)}
        disabled={disabled || num >= max}
        aria-label="Añadir uno"
        tabIndex={-1}
      >
        +
      </button>
    </div>
  );
}
